import {ErrorBoundary} from "react-error-boundary";
import {DashboardWrapper} from "../../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../../styles/dashboard/calls/calls";
import {Alert, Breadcrumb, Button} from "antd";
import {StyledHideStepsOnMobile} from "../../../../../components/offering-form/general/steps/styles";
import {CanvaTemplateWidget} from "../../../../../components/widgets/canva-template-widget";
import {CreateServiceFormSteps} from "../../../../../service-feature/useCases/create-service/multi-step/create-service-steps";
import {CreateServiceMultiStepFormWrapper} from "../../../../../service-feature/useCases/create-service/multi-step/multi=step-form-wrapper";
import {CreateServiceContextWrapper} from "../../../../../service-feature/useCases/create-service/context/create-service/context-wrapper";
import {Link} from "react-router-dom";

export function ServiceCreationPage() {
  return (
    <DashboardWrapper pageTitle="Create a new service">
      <CreateServiceContextWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/products?activeTab=services">Services</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create a new service</Breadcrumb.Item>
        </Breadcrumb>
        <StyledPageWrapper>
          <div className="main-area">
            <ErrorBoundary
              FallbackComponent={({error, resetErrorBoundary}) => (
                <Alert
                  message="Sorry, something went wrong."
                  showIcon
                  description={error.message}
                  type="error"
                  action={
                    <Button
                      onClick={() => {
                        resetErrorBoundary();
                      }}
                      size="small"
                      danger
                    >
                      Reset
                    </Button>
                  }
                />
              )}
            >
              <CreateServiceMultiStepFormWrapper />
            </ErrorBoundary>
          </div>
          <div className="widget-area">
            <StyledHideStepsOnMobile>
              <CreateServiceFormSteps />
            </StyledHideStepsOnMobile>
            <CanvaTemplateWidget url="https://www.canva.com/design/DAGPzxhigYA/gFsU5XQQ4j5DlxQnccruhg/view?utm_content=DAGPzxhigYA&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview" />
          </div>
        </StyledPageWrapper>
      </CreateServiceContextWrapper>
    </DashboardWrapper>
  );
}
